var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 145 79",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M141.836,69.408c0.801,0.801 1.251,1.887 1.251,3.02c0,1.133 -0.45,2.219 -1.251,3.02c-0.001,0.001 -0.002,0.002 -0.003,0.003c-0.761,0.761 -1.793,1.188 -2.87,1.188c-1.076,0 -2.108,-0.427 -2.87,-1.188c-12.753,-12.753 -63.665,-63.666 -63.665,-63.666c0,0 -50.913,50.913 -63.666,63.666c-0.761,0.761 -1.793,1.188 -2.869,1.188c-1.077,0 -2.109,-0.427 -2.87,-1.188c-0.001,-0.001 -0.002,-0.002 -0.003,-0.003c-0.801,-0.801 -1.251,-1.887 -1.251,-3.02c0,-1.133 0.45,-2.219 1.251,-3.02c13.707,-13.708 69.408,-69.408 69.408,-69.408c23.136,23.136 46.272,46.272 69.408,69.408Z",
    style: {
      fill: "#858585"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.55fcd1ff5260a181b209a22200e8482d.svg";
export { ForwardRef as ReactComponent };